module.exports = __webpack_public_path__ + "static/media/dz.ff15f060.svg";